import React from 'react';

import { Icon, Label } from '@atlas/ui';

import { scrollToTopHandler } from './scrollToTopHandler';

const FooterUpButton = () => (
  <button className="up-button" onClick={scrollToTopHandler} type="button">
    <Icon name="m-arrow-down" />
    <Label message="up" />
  </button>
);

export default FooterUpButton;
